import React, { useEffect } from "react";
import { connect } from "react-redux";

import { defineMessages, useIntl } from "react-intl";

import { EntityType } from "@mapmycustomers/shared/enum";
import useBoolean from "@mapmycustomers/shared/util/hook/useBoolean";
import { Alert, Button } from "@mapmycustomers/ui";

import {
  getActiveEntityType,
  isCreating,
  isEditingChildLayout,
} from "@app/scene/settings/component/FormLayouts/store";
import { RootState } from "@app/store/rootReducer";

import styles from "./ActivityNotification.module.scss";

interface Props {
  creating: boolean;
  isActivity: boolean;
  isEditingChildLayout: boolean;
}

const messages = defineMessages({
  button: {
    id: "settings.formLayouts.canvas.activity.button.title",
    defaultMessage: "Got it",
    description: "Title of Got it button",
  },
  line1: {
    id: "settings.formLayouts.canvas.activity.message.line1",
    defaultMessage: "Activity Layouts apply to <u>both creation and edit</u> of an activity",
    description: "Line 1 of notification for activities",
  },
  line2: {
    id: "settings.formLayouts.canvas.activity.message.line2",
    defaultMessage: "Fields are only required to log an activity as Completed",
    description: "Line 2 of notification for activities",
  },
  title: {
    id: "settings.formLayouts.canvas.activity.message.title",
    defaultMessage: "Activity Layouts are different from Companies, People, and Deals:",
    description: "Title of notification for activities",
  },
});

const ActivityNotification: React.FC<Props> = ({ creating, isActivity, isEditingChildLayout }) => {
  const intl = useIntl();
  const [visible, , hide] = useBoolean(creating && isActivity && !isEditingChildLayout);

  useEffect(() => {
    if (!creating || !isActivity) {
      hide();
    }
  }, [creating, isActivity, hide]);

  if (!visible || isEditingChildLayout) {
    return null;
  }

  return (
    <Alert
      action={
        <Button onClick={hide} type="primary">
          {intl.formatMessage(messages.button)}
        </Button>
      }
      className={styles.alert}
      description={
        <ul>
          <li>
            {intl.formatMessage(messages.line1, {
              u: (text) => <u>{text}</u>,
            })}
          </li>
          <li>{intl.formatMessage(messages.line2)}</li>
        </ul>
      }
      message={intl.formatMessage(messages.title)}
    />
  );
};

const mapStateToProps = (state: RootState) => ({
  creating: isCreating(state),
  isActivity: getActiveEntityType(state) === EntityType.ACTIVITY,
  isEditingChildLayout: isEditingChildLayout(state),
});

export default connect(mapStateToProps)(ActivityNotification);
